import React, { useState, useRef } from 'react';
import { Carousel } from '@mantine/carousel';
import {
  Container,
  Image,
  Title,
  Text,
  Button,
  Center,
  useMantineTheme,
  Divider,
} from '@mantine/core';

import meter1Img from '../Images/meter4.jpg';
import meter2Img from '../Images/meter2.jpg';
import meter3Img from '../Images/meter3.jpg';

import paris1Img from '../Images/paris1.png';
import paris2Img from '../Images/paris2.png';
import paris3Img from '../Images/paris3.png';
import paris4Img from '../Images/paris4.png';

const newsItems = [
  {
    title: 'International Paris Air Show (16 - 19 June 2025)',
    description: 'We participated in the International Paris Air Show (June 16–19, 2025), one of the world’s premier events for the aerospace and aviation industry. During the exhibition, we had the opportunity to meet and engage with a wide range of customers and partners from the aerospace sector. These included manufacturers, system integrators, and suppliers who are actively involved in the production and development of aircraft, satellites, and defense technologies.',
    images: [paris1Img, paris2Img,paris3Img,paris4Img],
  },
  {
    title: 'METEF 2025  (05 - 07 March 2025)',
    description: 'We are excited to announce that DANAXSSERT International Trading GmbH has successfully participated in the METEF 2025, the International Trade Fair for the Aluminum Supply Chain, held from March 5th to 7th, where we showcased our latest innovations and connected with industry leaders.',
    images: [meter1Img, meter2Img, meter3Img],
  },
];

const News = () => {
  const theme = useMantineTheme();
  const [visibleCount, setVisibleCount] = useState(1);
  const newsRefs = useRef<(HTMLElement | null)[]>([]);

  const showNext = () => {
    const nextIndex = visibleCount;
    setVisibleCount((prev) => prev + 1);
    setTimeout(() => {
      newsRefs.current[nextIndex]?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 100);
  };

  const carouselContent = {
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column' as const,
    backgroundColor: theme.colors.yellow[5],
    borderRadius: 15,
    gap: 15,
  };

  return (
    <section style={{ padding: '2rem 0' }}>
      <Container>
        <Text color="black" align="center" mb="15px">
          <Title order={1}>News</Title>
        </Text>

        <Text color="black" align="center" mb="25px">
          Updates and highlights from our recent exhibitions and events.
        </Text>

        {newsItems.map((item, idx) =>
          visibleCount > idx ? (
            <div
              key={idx}
              ref={(el) => (newsRefs.current[idx] = el)}
              style={{ marginBottom: '3rem' }}
            >
              <Title order={2} style={{ marginBottom: '1rem' }}>
                {item.title}
              </Title>
              <Text style={{ marginBottom: '1rem' }}>{item.description}</Text>

              <Carousel
                withIndicators
                height={300}
                slideSize="33.333333%"
                slideGap="md"
                breakpoints={[
                  { maxWidth: 'md', slideSize: '50%' },
                  { maxWidth: 'sm', slideSize: '80%', slideGap: 15 },
                ]}
                loop
                align="start"
                pr="15px"
                pl="15px"
              >
                {item.images.map((img, index) => (
                  <Carousel.Slide key={index}>
                    <div style={carouselContent}>
                      <Image
                        src={img}
                        alt={`img-${index}`}
                        style={{ width: '90%' }}
                      />
                    </div>
                  </Carousel.Slide>
                ))}
              </Carousel>

              {idx === visibleCount - 1 && visibleCount < newsItems.length && (
                <Center mt="lg">
                  <Button
                    variant="light"
                    onClick={showNext}
                    radius="xl"
                    size="lg"
                    leftIcon={<span style={{ fontSize: '20px' }}>↓</span>}
                  >
                    Next
                  </Button>
                </Center>
              )}

              <Divider my="lg" />
            </div>
          ) : null
        )}
      </Container>
    </section>
  );
};

export default News;
